import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import reduxLoggerPkg from 'redux-logger';
import thunkPkg from 'redux-thunk';

import { checkIsSsr } from '@shared/utils/check-is-ssr';

import {
  campaigns,
  dashboards,
  reports,
  sidebarReducer,
  stat,
  themeReducer,
  usersReducer,
} from './redux/reducers/index';

// biome-ignore lint/suspicious/noExplicitAny: intentional
const thunk = (thunkPkg as any).default ?? thunkPkg;
// biome-ignore lint/suspicious/noExplicitAny: intentional
const logger = (reduxLoggerPkg as any).logger;

const middleWares = [thunk];
if (process.env.NODE_ENV !== 'production' && !checkIsSsr() && logger) {
  middleWares.push(logger);
}

const reducer = combineReducers({
  form: reduxFormReducer,
  theme: themeReducer,
  sidebar: sidebarReducer,
  users: usersReducer,
  campaigns: campaigns,
  stat: stat,
  dashboards: dashboards,
  reports: reports,
});

export function configureStore() {
  const store = createStore(reducer, compose(applyMiddleware(...middleWares)));

  return store;
}

export default configureStore();
